import * as Types from '../Constants/AllConstants';

// Unpaged list
export const GetAllProductCategoriesReducer = (state = { categories: [] }, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_LIST_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_LIST_SUCCESS:
      return { loading: false, categories: action.payload };
    case Types.PRODUCT_CATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Paged list
export const GetPagedProductCategoriesReducer = (state = { categories: [], page: 0, pages: 0 }, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_PAGED_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_PAGED_SUCCESS:
      return {
        loading: false,
        categories: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.PRODUCT_CATEGORY_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Single details
export const ProductCategoryDetailsReducer = (state = { category: {} }, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_DETAILS_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_DETAILS_SUCCESS:
      return { loading: false, category: action.payload };
    case Types.PRODUCT_CATEGORY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create
export const CreateProductCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_CREATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_CREATE_SUCCESS:
      return { loading: false, success: true, category: action.payload };
    case Types.PRODUCT_CATEGORY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PRODUCT_CATEGORY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update
export const UpdateProductCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_UPDATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_UPDATE_SUCCESS:
      return { loading: false, success: true, category: action.payload };
    case Types.PRODUCT_CATEGORY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PRODUCT_CATEGORY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete
export const DeleteProductCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_CATEGORY_DELETE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CATEGORY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PRODUCT_CATEGORY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
